export function thresholdCalculator<Type>(
  percentage: number,
  thresholds: { threshold: number; value: Type }[]
): Type {
  const sortedThresholds = [...thresholds].sort((thresholdA, thresholdB) => {
    return thresholdA.threshold - thresholdB.threshold;
  });
  return sortedThresholds.reduce((closestThreshold, threshold) => {
    return threshold.threshold < percentage ? threshold : closestThreshold;
  }, null)?.value;
}
